export const QUICK_ACTIONS_SECTION_KEY = 'QUICK_ACTIONS';